import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-addalerttype',
  templateUrl: './addalerttype.component.html',
  styleUrls: ['./addalerttype.component.css']
})
export class AddalerttypeComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname: string = "AlertType";

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;   


//Save Validation
submitted:boolean;
  successfully: boolean;
  saveloading: boolean;

//Edit Get Values
alerttypeColl:any=[];
alerttypeBO: any = {};
alerttypeid:number=0

alerttypeform=new FormGroup({
  alerttypeid:new FormControl(0),          
  alerttypename:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.alerttypeid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.alerttypeform.reset();
       this.fnInitializeFormGroup(); 

       if(this.alerttypeid>0){
         this.fngetAlertType();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.alerttypeid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}  
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.alerttypeform.setValue({
    alerttypeid:0,    
    alerttypename:'',
     inactive:false              
   })
}

//Get 
fngetAlertType() {  
  if (this.showProgress) {
    return;
  }        
     var data = {
       'alerttypeid':this.alerttypeid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getAlerttype(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){
          this.fnHideProgress();
  
           this.alerttypeColl=res.json().result;
           var editdata = this.alerttypeColl[0];        
           this.fnEditMode(editdata);
           this.alerttypeBO = editdata;

         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{  
      this.fnHideProgress();
        
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
  try {
    if (this.saveloading) {
      return;        
    }

     this.submitted=true;
     this.successfully=false;
     //Validate
    if (this.alerttypeform.valid) {
          this.saveloading = true;

         //Check
         var data = {
               'alerttypeid': this.alerttypeid,                      
               'alerttypename':this.alerttypeform.get('alerttypename').value, 
               'inactive':this.alerttypeform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckAlerttype(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.alerttypeform.get('alerttypeid').value>0){
                       //Update 
                       this.fnSetAlertType(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertAlertType(data);
                     }
               }
               else{        
                 if (_checkresult === "name") {
                  this.saveloading = false;
                       this.alerttypeform.controls['alerttypename'].setErrors({'notfound': true});
                     }
               }
             }
             else {
              this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
           (err) => {
            this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
  } catch (ex) {
    this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertAlertType(data){    
 
   this.appService.fnInsertAlerttype(data).subscribe(
     (res) => {
      this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){
           this.toastr.success('', "The new alerttype has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.alerttypename);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err) => {
      this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetAlertType(data){    

this.appService.fnSetAlerttype(data).subscribe(
  (res) => {
    this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The alerttype has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.alerttypeid,data.alerttypename);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
  (err) => {
    this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/Alerttype']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.alerttypeform.setValue({ 
  alerttypeid:deptBO.alerttypeid,     
  alerttypename:deptBO.alerttypename,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
} 
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}







}
